"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineTranslation = void 0;
const core_1 = require("../core");
/**
 * Machine Translation Engines (MTE) are the sources for pre-translations.
 * You can currently connect Google Translate, Microsoft Translator, Yandex. Translate, DeepL Pro, Amazon Translate, and Watson (IBM) Translate engines.
 *
 * Use API to add, update, and delete specific MTE.
 */
class MachineTranslation extends core_1.CrowdinApi {
    listMts(options, deprecatedLimit, deprecatedOffset) {
        if ((0, core_1.isOptionalNumber)(options, '0' in arguments)) {
            options = { groupId: options, limit: deprecatedLimit, offset: deprecatedOffset };
        }
        let url = `${this.url}/mts`;
        url = this.addQueryParam(url, 'groupId', options.groupId);
        return this.getList(url, options.limit, options.offset);
    }
    /**
     * @param request request body
     * @see https://support.crowdin.com/enterprise/api/#operation/api.mts.post
     */
    createMt(request) {
        const url = `${this.url}/mts`;
        return this.post(url, request, this.defaultConfig());
    }
    /**
     * @param mtId mt identifier
     * @see https://developer.crowdin.com/api/v2/#operation/api.mts.getMany
     */
    getMt(mtId) {
        const url = `${this.url}/mts/${mtId}`;
        return this.get(url, this.defaultConfig());
    }
    /**
     * @param mtId mt identifier
     * @see https://support.crowdin.com/enterprise/api/#operation/api.mts.delete
     */
    deleteMt(mtId) {
        const url = `${this.url}/mts/${mtId}`;
        return this.delete(url, this.defaultConfig());
    }
    /**
     * @param mtId mt identifier
     * @param request request body
     * @see https://support.crowdin.com/enterprise/api/#operation/api.mts.patch
     */
    updateMt(mtId, request) {
        const url = `${this.url}/mts/${mtId}`;
        return this.patch(url, request, this.defaultConfig());
    }
    /**
     * @param mtId mt identifier
     * @param request request body
     * @see https://developer.crowdin.com/api/v2/#operation/api.mts.translations.post
     */
    translate(mtId, request) {
        const url = `${this.url}/mts/${mtId}/translations`;
        return this.post(url, request, this.defaultConfig());
    }
}
exports.MachineTranslation = MachineTranslation;
